import { UIComponentState, UIComponentProps, UIComponentImpl, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { LandingPageErrorViewImpl } from './landingpageerrorview';
import { LandingPageErrorCSSStyleImpl } from './landingpageerrorcss';

export interface LandingErrorComponentProps extends UIComponentProps
{

}


export class LandingErrorComponent extends UIComponentImpl<LandingErrorComponentProps, UIComponentState, UIDataModel>
{
    constructor(props: LandingErrorComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new  LandingPageErrorViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new  LandingPageErrorCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/landingpage/error/landingpageerrorcomponent.tsx